import React, { useState, useEffect } from "react";
import { withRouter, useParams } from "react-router-dom";
import axios from "axios";

import config from "../../config";
import FooterComponent from "../../components/FooterComponent";
import TnCDialog from "../BookWithUs/TnCDialog";
import JoyRides from "../BookWithUs/JoyRides";

import "./index.css";

const BANNER_STYLES = {
  default: {
    className: "schedule-banner",
    titleStyle: {
      margin: 0,
      textAlign: "center",
      fontSize: "70px",
      fontWeight: 600,
      color: "white",
      display: "flex",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      fontFamily: "Open Sans",
      position: "relative",
      zIndex: 1,
      paddingTop: "120px",
    },
    showImage: false,
    contentMargin: 300,
  },
};

const SCHEDULE_CONFIG = {
  "tumakur-by-sky-2026": {
    title: "Tumakur By Sky - Dasara 2026",
    pathName: "Tumakur By Sky - Dasara 2026",
    bannerImage: "/assets/tumkur-temple.jpg",
    bannerType: "default",
  },
  "hassan-by-sky": {
    title: "Hassan By Sky 2025",
    pathName: "Hassan By Sky",
    bannerImage: "/assets/hassan-by-sky.jpg",
    bannerType: "default",
  },
};

const BookingDetailComponent = (props) => {
  const { scheduleName } = useParams();
  const [joyRides, setJoyRides] = useState([]);
  const [loading, setLoading] = useState(false);
  const [termsnConditions, setTermsnConditions] = useState([]);
  const [scheduleDetails, setScheduleDetails] = useState(null);

  useEffect(() => {
    const details = SCHEDULE_CONFIG[scheduleName];
    if (!details) {
      props.history.push("/bookwithus?tab=joyride");
      return;
    }

    setScheduleDetails(details);
    setLoading(true);

    axios
      .get(config.baseUrl + "v2/schedules", {
        headers: {
          "x-helitaxii-client": "browser",
        },
      })
      .then((res) => {
        const joyRideSchedules = res.data.schedules.filter(
          (s) => s.type === "joyRide" && s.path.name === details.pathName
        );
        setJoyRides(joyRideSchedules);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [scheduleName, props.history]);

  if (!scheduleDetails) {
    return null;
  }

  const currentBannerStyle =
    BANNER_STYLES[scheduleDetails.bannerType] || BANNER_STYLES.default;

  return (
    <section
      id="booking-detail-page"
      style={{
        paddingTop: "60px",
        minHeight: "100vh",
      }}
    >
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: "#00529955",
            zIndex: 301,
            opacity: 0.75,
            display: loading ? "block" : "none",
          }}
        >
          <div className="lds-roller">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <TnCDialog
        termsnConditions={termsnConditions}
        onClose={() => setTermsnConditions([])}
      />

      <div
        className={`banner ${currentBannerStyle.className}`}
        style={{
          height: "400px",
          backgroundImage:
            !currentBannerStyle.showImage && scheduleDetails.bannerImage
              ? `url("${scheduleDetails.bannerImage}")`
              : undefined,
        }}
      >
        <h1 style={currentBannerStyle.titleStyle}>{scheduleDetails.title}</h1>
        {currentBannerStyle.showImage && (
          <img src={scheduleDetails.bannerImage} alt={scheduleDetails.title} />
        )}
      </div>
      <div style={{ minHeight: "400px" }}>
        {joyRides.length === 0 && !loading && (
          <div
            className="content-wrapper"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: `${currentBannerStyle.contentMargin}px`,
            }}
          >
            <div>
              <h4>
                We don&apos;t have any joy rides available at the moment. Please
                check back later.
              </h4>
            </div>
          </div>
        )}
        {joyRides.length > 0 && (
          <div
            className="content-wrapper"
            style={{
              padding: "20px",
              marginTop: `${currentBannerStyle.contentMargin}px`,
            }}
          >
            <JoyRides
              setTermsnConditions={setTermsnConditions}
              schedules={joyRides}
              setLoading={setLoading}
              returnUrl={`/book/${scheduleName}`}
            />
          </div>
        )}
      </div>
      <FooterComponent />
    </section>
  );
};

export default withRouter(BookingDetailComponent);
